module.exports = __webpack_public_path__ + "media/images/countrysquared/nr-b136a980a3862819b267487a0d0238b0.svg";